import { render, staticRenderFns } from "./UpdateMutiple.vue?vue&type=template&id=454f4e02&scoped=true&"
import script from "./UpdateMutiple.vue?vue&type=script&lang=js&"
export * from "./UpdateMutiple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454f4e02",
  null
  
)

export default component.exports